module.exports = __webpack_public_path__ + "04_mole.61dbd2af.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer3/04_mole.png
// module id = b71A
// module chunks = 0